// extracted by mini-css-extract-plugin
module.exports = {"outer":"AspectRatioContainer_outer__4stgl","inner":"AspectRatioContainer_inner__pemD7","withCssVariables":"AspectRatioContainer_withCssVariables__59n8W"};